import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModulosComponent } from './components/modulos/modulos.component';
import { OpcionesMenuComponent } from './components/opciones/opciones-menu.component';
import { RolesComponent } from './components/roles/roles.component';

const routes: Routes = [
  { path: "modulos", component: ModulosComponent, data: { title: "Modulos" } },
  { path: "opciones", component: OpcionesMenuComponent, data: { title: "Opciones" } },
  { path: "roles", component: RolesComponent, data: { title: "Roles" } },
  { path: "", redirectTo: "modulos", pathMatch: "prefix" }, { path: "**", redirectTo: "modulos", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ModulosRoutingModule { }
